// ProfileCard.js
import React, { useState, useEffect } from 'react';
import ModalLvlUp from './modal/ModalLvlUp';
import VitalityCounter from './../parts/VitalityCounter';
import VitalityComponent from './../parts/VitalityComponent'
const ProfileCard = ({ personnage,setEnergies, token }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  var nom = personnage.nom_magique != null ? personnage.nom_magique : personnage.nom;
  const formatTaille = (taille) => {
    const metres = Math.floor(taille / 100);
    const centimetres = taille % 100;
    return `${metres}m${centimetres}`;
  };
  return (
    <div className="card_Wrapper" >
      <div>
        <img className='profil_pic border-profil' src={personnage.profilPath} alt="Profile" />

      </div>

      <div className='infos_diverse'>
        <div><strong>Age : </strong>{personnage.Age}</div>
        <div><strong>Taille </strong>{formatTaille(personnage.Taille)}</div>
        <div><strong>Origine : </strong>{personnage.Origine}</div>
        <div><strong>Race : </strong>{personnage.Race}</div>
        <div onClick={() => { setIsModalOpen(true) }}><strong>Niveau :</strong> {personnage.Niveau}</div>

      </div>
      {/* <div className='flex'>
      <span></span> */}
      {/* <Hearth></Hearth>
      <Lightning></Lightning> */}
      <VitalityComponent idPerso={personnage.idPersonnage} setVariable={setEnergies} token={token}  />
      {/* </div> */}
      <ModalLvlUp
        isOpen={isModalOpen}
        personnage={personnage}
        setOpen={setIsModalOpen}
        token={token}
      />
    </div>
  );
};



export default ProfileCard;
